export default "__VITE_ASSET__31209911__"